<template>
  <section class="bg-white shadow p-3 mt-4">
    <h2>QR-Code Trennzeichen</h2>

    <LoadingSpinner v-if="loading" />

    <div v-else class="alert alert-success">
      <p class="m-0"><strong>Aktuelles Trennzeichen:</strong> {{ trennzeichen }}</p>
    </div>

    <div class="mb-3 mt-4 w-25">
      <label for="new-qr-code-trennzeichen" class="form-label">Neues Trennzeichen</label>

      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          id="new-qr-code-trennzeichen"
          v-model="editTrennzeichen.qrCodeTrennzeichen"
          aria-describedby="new-qr-code-trennzeichen-button"
        />
        <button class="btn btn-outline-secondary" type="button" id="new-qr-code-trennzeichen-button" @click="setQRCodeTrennzeichen()">
          <font-awesome-icon icon="save" />
        </button>
      </div>
    </div>

    <div v-if="errorMsg.length > 0" class="alert alert-danger">{{ errorMsg }}</div>
  </section>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, ref } from 'vue';

  import { useStore } from '@/store';

  import { ActionTypes as CommonActionTypes } from '@/store/modules/Common/actions';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import { UpsertEinstellungQRCodeTrennzeichen } from '@/models/CommonModels';
  //#endregion

  const store = useStore();

  const loading = computed(() => store.getters.status.getEinstellungenLoading || store.getters.status.updateEinstellungenLoading);
  const errorMsg = computed(() => store.getters.status.einstellungenErrorMsg);

  const trennzeichen = computed(() => store.getters.qrCodeTrennzeichen);

  async function getQRCodeTrennzeichen() {
    await store.dispatch(CommonActionTypes.GetQRCodeTrennzeichen, undefined);
  }

  const editTrennzeichen = ref(new UpsertEinstellungQRCodeTrennzeichen());

  async function setQRCodeTrennzeichen() {
    await store.dispatch(CommonActionTypes.SetQRCodeTrennzeichen, editTrennzeichen.value);

    if (errorMsg.value.length === 0) {
      editTrennzeichen.value = new UpsertEinstellungQRCodeTrennzeichen();
    }
  }

  onMounted(() => {
    getQRCodeTrennzeichen();
  });
</script>
